import type { GeneralRaisingHistoryFilters } from "../api/generalRaisingHistory/generalRaisingHistory.types";
import type { GeneralReservoirManagementFilters } from "../api/generalReservoirManagement/generalReservoirManagement.types";

export type GeneralDashboardTableSort = {
  key: string;
  direction: string;
};

const RAISING_HISTORY_COLUMN_TO_API_SORT: Record<string, string> = {
  stage: "stage",
  methodDisplay: "method",
  elevation: "elevation",
  occurredOnDisplay: "occurredOn",
};

const RESERVOIR_MANAGEMENT_COLUMN_TO_API_SORT: Record<string, string> = {
  recordedOnDisplay: "recordedOn",
  occupiedArea: "occupiedArea",
  totalVolume: "totalVolume",
  totalOccupiedVolume: "totalOccupiedVolume",
  availableVolume: "availableVolume",
  rejectOccupiedVolume: "rejectOccupiedVolume",
  waterOccupiedVolume: "waterOccupiedVolume",
  waterLevel: "waterLevel",
};

export const mapRaisingHistorySortToApi = (
  sort: GeneralDashboardTableSort | null,
): Pick<GeneralRaisingHistoryFilters, "sortBy" | "sortOrder"> => {
  if (!sort) return {};

  const sortBy = RAISING_HISTORY_COLUMN_TO_API_SORT[sort.key];
  if (!sortBy) return {};

  return {
    sortBy,
    sortOrder: sort.direction as "asc" | "desc",
  };
};

export const mapReservoirManagementSortToApi = (
  sort: GeneralDashboardTableSort | null,
): Pick<GeneralReservoirManagementFilters, "sortBy" | "sortOrder"> => {
  if (!sort) return {};

  const sortBy = RESERVOIR_MANAGEMENT_COLUMN_TO_API_SORT[sort.key];
  if (!sortBy) return {};

  return {
    sortBy,
    sortOrder: sort.direction as "asc" | "desc",
  };
};
